import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'

import { Person } from 'civic-champs-shared/common/types'

export interface SetContactMethodPromptProps {
  showing: boolean
  complete: (result: { completed: boolean; value?: string }) => void
  person: Person
}

export default function SetContactMethodPrompt(props: SetContactMethodPromptProps) {
  const { showing, complete, person } = props

  const [contactMethod, setContactMethod] = useState(person.preferredContactMethod as string)
  const handleChange = (event: any) => {
    setContactMethod(event.target.value)
  }

  const close = () => {
    complete({ completed: false })
  }

  const onSubmit = () => {
    complete({ completed: true, value: contactMethod })
  }

  return (
    <Dialog open={showing} onClose={close}>
      <DialogTitle>Set Preferred Contact Method</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="contact-method-label">Contact Method</InputLabel>
          <Select id="contact-method" labelId="contact-method-label" value={contactMethod} onChange={handleChange}>
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="phone">Phone</MenuItem>
            <MenuItem value="do-not-contact">Do Not Contact</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={onSubmit}>Update</Button>
      </DialogActions>
    </Dialog>
  )
}
